import { max } from 'date-fns';
import { LoadingState } from '../types';
/**
 * Updates a [[FetchedData]] object by merging a newer [[FetchedData]] value, similar to Object.assign.
 *
 * Retains the longest expiry time to prevent premature cache expiry.
 *
 * @returns Returns the updated [[FetchedData]].
 */
export function updateFetchedData(target, source) {
    // When replacing previously loaded data, ensure that the updated data doesn't have a shorter expiry time.
    if (target.loadingState === LoadingState.Success && source.loadingState === LoadingState.Success) {
        const previousExpiry = new Date(target.expiresAt);
        const newExpiry = new Date(source.expiresAt);
        Object.assign(target, Object.assign(Object.assign({}, source), { expiresAt: max([previousExpiry, newExpiry]).toISOString() }));
    }
    else {
        Object.assign(target, source);
    }
    return target;
}
//# sourceMappingURL=update-fetched-data.js.map